// extracted by mini-css-extract-plugin
module.exports = {"tabBodyItemActive":"tabBodyItemActive-2Lha1nk0","tabBodyItem":"tabBodyItem-2JYqfsvy"};